import { useState } from "react";

import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import SelectMenu from "../../controls/SelectMenu";
import ButtonSpinner from "../../controls/ButtonSpinner";

export default function DeleteWipOutputItemByIdForm(props) {
  const {
    item,
    onDeleteWipOutputItemByBarcode,
    removeReasonFromWipOptions,
    setEmptyModelOpen,
  } = props;

  const [reasonSelected, setReasonSelected] = useState({ value: -1 });
  const [error, setError] = useState(null);

  const removeItemFormActionCall = async function () {
    if (reasonSelected.value > 0) {
      const result = await onDeleteWipOutputItemByBarcode(reasonSelected);
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
    } else {
      setError("Select a reason");
    }
  };

  return (
    <form>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <ExclamationCircleIcon
            className="h-11 w-11 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-start sm:mt-5">
          <p
            as="h3"
            className="text-center text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Delete output item from WIP
          </p>
          <div className="mt-2">
            <p>
              {item.product_name} - {item.plu}
            </p>
            <p>{item.lot_number}</p>
            <p>{item.barcode}</p>
          </div>
          <div className="mt-2 space-y-4 grid grid-cols-2 gap-4">
            <SelectMenu
              handleInputChange={(e) => setReasonSelected(e.target.value)}
              name="reason_selected"
              options={removeReasonFromWipOptions}
              value={reasonSelected}
              title={"Reason"}
              parentClass="col-span-2"
              error={error}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
          onClick={() =>
            setEmptyModelOpen({ childComponent: null, open: false })
          }
        >
          Cancel
        </button>
        <button
          type="button"
          className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={removeItemFormActionCall}
        >
          <ButtonSpinner spin={false} text="OK" />
        </button>
      </div>
    </form>
  );
}
